<template>
  <div id="shops-list-component">
    <div class="cards row row-cards">
      <template v-if="isNotFound(items) && !busy">
        <span class="items-not-found">Ничего не найдено</span>
      </template>
      <template v-else>
        <div class="col-md-6 col-lg-3" v-for="item in items" :key="row.getId(item)" :class="{'no-active': !row.getActive(item)}">
          <div class="card">
            <div class="card-body p-4 text-center">
              <span data-bs-toggle="modal" data-bs-target="#modal-shop" data-type="update" :data-id="row.getId(item)">
                <span class="avatar avatar-xl mb-3" :style="{ backgroundImage: 'url(' + row.getImage(item, 300) + ')' }"></span>
              </span>
              <h3 class="m-0 mb-2">
                <span>{{ row.getTitle(item) }}</span>
              </h3>
              <div class="mb-2">
                <span class="badge bg-blue-lt">{{ row.getCategoryName(item) }}</span>
              </div>
              <div class="mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-pencil icon-small me-1">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
                  <path d="M13.5 6.5l4 4" />
                </svg>
                <span class="small">{{ row.getUpdatedAt(item) }}</span>
              </div>
            </div>
            <div class="d-flex">
              <a href="#" class="card-btn" data-bs-toggle="modal" data-bs-target="#modal-shop" data-type="update" :data-id="row.getId(item)">
                <IconEdit class="me-2 text-muted" />
                Изменить
              </a>
            </div>
          </div>
        </div>
      </template>
      <div class="loader-posts">
        <div class="spinner-border" v-show="busy"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import IconEdit from '@/assets/icons/IconEdit.vue'
import {defineComponent, ref, watch} from "vue"
import element from "@/modules/shops/pages/shops/components/list/services/element"
import ShopImage from "@/modules/shops/services/ShopImage"
import Helper from "@/services/Helper"
import Api from "@/modules/shops/pages/shops/services/Api"
import DT from "@/services/DT"

export default defineComponent({
  name: "List",
  components: {
    IconEdit,
  },
  props: {
    query: {
      type: Object,
      required: true
    },
    clearResult: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {emit}) {
    let busy = ref(false)
    let items = ref([])
    let eofItems = ref(false)
    let countItems = ref(0)

    let row = {
      getId: (item) => {
        return element.getId(item)
      },

      getTitle: (item) => {
        return element.getTitle(item)
      },

      getCategoryId: (item) => {
        return element.getCategoryId(item)
      },

      getCategoryName: (item) => {
        return element.getCategoryName(item)
      },

      getImage: (item, w) => {
        let image = element.getImage(item)

        if (image !== null) {
          return getImage(image["host"], image["name"], w)
        } else {
          return getImage(null, null, w)
        }
      },

      getActive: (item) => {
        return element.getActive(item)
      },

      getUpdatedAt: (item) => {
        let dt = new DT(element.getUpdatedAt(item))

        return dt.get("%D.%M.%Y %H:%I")
      },
    }

    function isNotFound(items) {
      return Helper.isEmptyObject(items)
    }

    function getImage(host, name, w = null, h = null) {
      return ShopImage.handle(host, name, w, h)
    }

    watch(() => props.query, (query) => {
      busy.value = true

      if (props.clearResult) {
        clearResult()
      }

      load(query)
    })

    function clearResult() {
      eofItems.value = false
      countItems.value = 0
      items.value = []
    }

    function load(query, offset = null) {
      if (offset !== null) {
        query.offset = offset;
      }

      Api.items(query).then((resp) => {
        let data = resp.data

        items.value.push(...data.items)

        if (data.items.length === 0) {
          eofItems.value = true
        }

        countItems.value = data.count
      }).finally(() => {
        busy.value = false

        emit("onRender", {
          "oef_items": eofItems.value,
          "count_items": countItems.value
        })
      })
    }

    /*function reload() {
      clearResult()
      load(props.query, 0)
    }*/

    return {
      busy,
      items,
      row,
      isNotFound,
    }
  }
})
</script>
